<div class="add-stock">

  <div class="add-stock__head">
    <div class="add-stock__img">
      <img *ngIf="imageUrl" [src]="imageUrl" alt="Komponens fotó">
      <span *ngIf="!imageUrl" class="add-stock__img-ph">kép</span>
    </div>
    <div class="add-stock__titles">
      <div class="add-stock__title">Készlet módosítása</div>
      <div class="add-stock__sub" *ngIf="fetchedComponent">{{ fetchedComponent.name }} · {{ fetchedComponent.sku }}</div>
      <div class="add-stock__sub" *ngIf="!fetchedComponent">Betöltés…</div>
    </div>
    <button type="button" class="add-stock__close" title="Bezárás" (click)="closeDialog(false)">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="5" y1="5" x2="19" y2="19"></line><line x1="19" y1="5" x2="5" y2="19"></line></svg>
    </button>
  </div>

  <form [formGroup]="stockForm" (ngSubmit)="saveStock()">

    <div class="add-stock__modes">
      <button type="button" class="add-stock__mode" [class.add-stock__mode--active]="mode === 'add'" (click)="mode = 'add'">Hozzáadás</button>
      <button type="button" class="add-stock__mode" [class.add-stock__mode--active]="mode === 'remove'" (click)="mode = 'remove'">Kivétel</button>
    </div>

    <div class="add-stock__label">Megadás módja</div>
    <div class="add-stock__options">
      <button type="button" class="add-stock__option" [class.add-stock__option--active]="inputOption === 1" (click)="inputOption = 1">Pontos mennyiség</button>
      <button type="button" class="add-stock__option" [class.add-stock__option--active]="inputOption === 2" (click)="inputOption = 2">Súly</button>
    </div>

    <div class="add-stock__qty" *ngIf="inputOption === 1">
      <input type="number" step="1" min="1" max="9999999999999999" placeholder="Darabszám" formControlName="quantity">
      <span>db</span>
    </div>
    <div class="add-stock__qty" *ngIf="inputOption === 2">
      <input type="number" step=".01" min="0.01" placeholder="Súly" formControlName="weight">
      <span>g</span>
    </div>

    <div class="add-stock__preview">{{ previewText }}</div>

    <div class="add-stock__label">Megjegyzés</div>
    <textarea class="add-stock__comment" placeholder="Megjegyzés…" rows="2" formControlName="comment"></textarea>

    <div class="add-stock__actions">
      <button type="button" class="add-stock__cancel" (click)="closeDialog(false)">Mégse</button>
      <button type="submit" class="add-stock__save" [disabled]="isSaving">{{ isSaving ? 'Mentés…' : 'Mentés' }}</button>
    </div>
  </form>

</div>
